import { Info, Loader2 } from 'lucide-react'
import { useState } from 'react'

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/_components/ui'

interface CreateConfirmProps {
  guarantorOrPatient: string
  isPending: boolean
  handleSubmit: () => Promise<void>
}

export const CreateConfirmDialog = ({
  guarantorOrPatient,
  isPending,
  handleSubmit,
}: CreateConfirmProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const onSubmit = async () => {
    setIsSubmitting(true)
    await handleSubmit()
    setIsSubmitting(false)
    setIsDialogOpen(false)
  }

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button type="button" className="w-[142px] font-bold" disabled={isPending}>
          {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Continuar
        </Button>
      </DialogTrigger>
      <DialogContent overlayClassName="z-[60]" className="z-[60] w-[400px] py-4">
        <DialogHeader className="flex flex-row items-center gap-1 text-base font-bold text-brand-grayscale-12">
          <Info
            className="flex-shrink-0 flex-grow-0 basis-6 text-brand-green-primary-5"
            size={22}
          />
          Aviso sobre os dados
        </DialogHeader>

        <div className="flex flex-col gap-[14px]">
          <p className="text-sm text-brand-grayscale-7">
            Ao clicar em “Continuar”, você confirma que o {guarantorOrPatient} concordou com os{' '}
            <a
              href="/documents/terms-of-use.pdf"
              target="_blank"
              className="font-bold text-brand-green-primary-5 underline"
            >
              Termos de Uso
            </a>{' '}
            e a
            <a
              href="/documents/privacy-policy.pdf"
              target="_blank"
              className="font-bold text-brand-green-primary-5 underline"
            >
              {' '}
              Política de Privacidade
            </a>{' '}
            da Dr. Sim e autorizou o uso de seus dados com uma instituição parceira via SCR (Sistema
            de Informação de Crédito) para fins de análise de crédito.
          </p>
        </div>

        <div className="mt-5 flex justify-end gap-3">
          <DialogClose asChild>
            <Button variant="gray" size="xs" className="font-bold">
              Voltar
            </Button>
          </DialogClose>
          <Button size="xs" onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Continuar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
